export default __webpack_public_path__ + "static/media/post4.3dbe3f8f.jpg";